import React from 'react';
import { GroupDimension, PrimaryGroup } from '../types';
import { SkuRow } from '../SkuRow/SkuRow';
import './SkuTable.scss';

interface SkuTableProps {
  group: PrimaryGroup;
  groupDimension: GroupDimension;
  openSkuRows: Set<string>;
  onToggleSkuRow: (rowKey: string) => void;
  onToggleHold: (holdKey: string) => void;
}

export const SkuTable: React.FC<SkuTableProps> = ({
  group,
  groupDimension,
  openSkuRows,
  onToggleSkuRow,
  onToggleHold,
}) => (
  <table className="sku-table">
    <thead>
      <tr>
        <th style={{ width: '36%' }}>SKU</th>
        <th>Ordered</th>
        <th>Pending</th>
        <th>In transit</th>
        <th>Next plan</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      {group.subGroups.map((sub) => (
        <React.Fragment key={sub.label}>
          <tr className="sku-table__subrow">
            <td colSpan={6}>{sub.label}</td>
          </tr>
          {sub.skuGroups.map((sg) => {
            const rowKey = `${group.key}||${sub.label}||${sg.sku}`;
            return (
              <SkuRow
                key={rowKey}
                skuGroup={sg}
                groupDimension={groupDimension}
                isOpen={openSkuRows.has(rowKey)}
                onToggle={() => onToggleSkuRow(rowKey)}
                onToggleHold={onToggleHold}
              />
            );
          })}
        </React.Fragment>
      ))}
    </tbody>
  </table>
);
